import React, { Component } from 'react';
import API from '../../api/api';
import './liveInfoList.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Tabs, Table, Button, Input, DatePicker, Select, Modal, message, InputNumber, Popconfirm, ConfigProvider } from 'antd';
import { thisExpression } from '@babel/types';
import TextArea from 'antd/lib/input/TextArea';
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

class LiveInfoList extends Component {
    constructor(props) {
        super(props);
        this.onPaginationChange = this.onPaginationChange.bind(this);
        this.onShowSizeChange = this.onShowSizeChange.bind(this);
    } 
    state = {
        totalAmount: '',// 铛铛币总额
        preTaxAmount: '',//税款
        receiveAmount: '',//收入总额
        waitForCheck:0,
        authInfoModal: {
            show: false,
            authId:'',//认证id
            userName: '',//真实姓名
            userCertNo: '',//身份证号
            userImages: [],//身份证照片
            status: 10//认证状态
        },
        freezeInfoModal: {
            show: false,
            reason: '',//封禁原因
            toUserId: '',//要封禁的用户id
        },
        showLiveList: [//直播列表数据
            // {
            //     showId: 1,//场次ID
            //     userId: 1,//用户ID
            //     nickName: '用户昵称1',//直播用户昵称
            //     circleId: 1,//公众圈ID
            //     circleName: '公众圈1',//公众圈名称
            //     startTime: '1111-11-11 11:11:11',//直播开始时间
            //     endTime: '1212-12-12 12:12:12',//直播结束时间
            //     showDuration: '15小时12分钟',//直播时长
            //     totalAmount: 1245800,//收入铛铛币
            //     preTaxAmount: 231300,//预扣税款
            //     receiveAmount: 2313100,//税后收入
            //     settleTime: '2020-4-22 12:00:01',//结算时间
            //     tradeNo: 12232332333441,//交易单号
            //     platformFreeze: 0,//全网封禁
            //     circleIdFreeze: 1,//公众圈内封禁
            // },
        ],
        showAuthList: [
            // {
            //     userId: 1,//用户ID
            //     nickName: '用户昵称1',//用户昵称
            //     authTime: '1111-11-11 11:11:11',//申请认证时间
            //     auditTime: '1212-12-12 12:12:12',//审核时间
            //     authType: 1, //审核方式 1 支付宝 2 人工
            //     status: 10,//(10-待审核 20-通过 30-拒绝)
            //     userName: '黄毓',
            //     userCertNo: '370983199705283210',
            //     userImages: ['http://s1.im-dangdang.com/online/20200304/1583301770087621.jpg', 'http://s1.im-dangdang.com/online/20200304/1583301770087621.jpg']
            // },
        ],
        showFreezeList: [
            // {
            //     freezeId: 1,
            //     userId: 1,
            //     nickName: '用户昵称',
            //     freezeType: '1',//封禁类型 1圈子 2 平台
            //     circleId: '12',
            //     circleName: '公众圈名称1',
            //     freezeTime: '封禁时间',
            //     unfreezeTime: '解封时间',
            //     isFreeze: 1,//封禁状态 0 未封禁 1 已封禁
            // },
        ],
        showAwardList: [
            // {
            //     rewardId: 11,//打赏ID
            //     userId: 123,//打赏用户ID
            //     userNick: 3133,//打赏用户昵称
            //     rewardType: 1,//打赏礼物
            //     rewardNum: 20,//打赏数量
            //     rewardDdb: 12,//礼物价值
            //     rewardTime: '2011-11-11',//打赏时间
            //     showId: 32,//场次ID
            //     showUserId: 3213,//主播用户ID
            //     showUserNick: '垂星河',//主播用户昵称
            // }, 
        ],
        showRecGoodsList: [
            // {
            //     showId: 12,//场次ID
            //     goodsId: 123,//商品ID
            //     goodsName: '开心果',//商品名称
            //     recStartTime: '2020-4-23 13:00:00',//讲解开始时间
            //     recEndTime: '2020-4-23 13:00:00',//讲解结束时间
            //     redDuration: '20分钟',//讲解时长
            //     recNum: 12,//带货数量
            // },
        ],
        activeKey: '1',
        loading: false,
        columnsOfLive: [//直播列表表头
            {
                title: '场次ID',
                dataIndex: 'showId',
                key: 'showId',
            },
            {
                title: '直播用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            {
                title: '直播用户昵称',
                dataIndex: 'nickName',
                key: 'nickName',
            },
            {
                title: '公众圈ID',
                dataIndex: 'circleId',
                key: 'circleId',
            },
            {
                title: '公众圈名称',
                dataIndex: 'circleName',
                key: 'circleName',
            },
            {
                title: '直播开始时间',
                dataIndex: 'startTime',
                key: 'startTime',
            },
            {
                title: '直播结束时间',
                dataIndex: 'endTime',
                key: 'endTime',
            },
            {
                title: '直播时长',
                dataIndex: 'showDuration',
                key: 'showDuration',
            },
            {
                title: '带货记录',
                key: 'record',
                render: (data) => (
                    <div className="operateBtnBlock">
                        <a onClick={this.goRecGoodsList.bind(this, data.showId,data.circleId)}>查看</a>
                    </div>
                ),
            },
            {
                title: '收入铛铛币',
                key: 'totalAmount',
                render: (data) => (
                    <div className="operateBtnBlock">
                        <a onClick={this.goRewardList.bind(this, data.showId, data.userId)}>{data.totalAmount / 100}</a>
                    </div>
                ),
            },
            {
                title: '结算比例',
                key: 'settlement',
                render: (data) => (
                    <span>10:1</span>
                ),
            },
            {
                title: '分成比',
                key: 'splitRatio',
                render: (data) => (
                    <span>50%</span>
                ),
            },
            {
                title: '预扣税款',
                dataIndex: 'preTaxAmount',
                key: 'preTaxAmount',
            },
            {
                title: '税后收入',
                dataIndex: 'receiveAmount',
                key: 'receiveAmount',
            },
            {
                title: '结算时间',
                dataIndex: 'settleTime',
                key: 'settleTime',
            },
            {
                title: '交易单号',
                dataIndex: 'tradeNo',
                key: 'tradeNo',
            },
            {
                title: '全网封禁',
                key: 'platformFreeze',
                render: (data) => (
                    <div className="operateBtnBlock">
                        {
                            data.freezeType == 0 ?
                                <Popconfirm title="确定全网封禁该直播吗？"
                                    onConfirm={this.deleteFuncOrDis.bind(this, 'freeze', data)}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button key={'deleteBtn' + data.showId} type="danger" className="deleteBtn">封禁</Button>
                                </Popconfirm>
                                :(data.freezeType == 2 ?<span className="hasFreeze">已封禁</span>:'')
                        }

                    </div>
                ),
            },
            {
                title: '公众圈内封禁',
                key: 'circleIdFreeze',
                render: (data) => (
                    <div className="operateBtnBlock">
                        {
                            data.freezeType == 1 ?<span className="hasFreeze">已封禁</span>:''
                                // <Popconfirm title="确定在该公众圈封禁该直播吗？"
                                //     onConfirm={this.deleteFuncOrDis.bind(this, 'freezeInCircle', data)}
                                //     okText="确定"
                                //     cancelText="取消"
                                // >
                                //     <Button key={'deleteBtn' + data.showId} type="danger" className="deleteBtn">封禁</Button>
                                // </Popconfirm>
                                // : <span className="hasFreeze">已封禁</span>
                        }

                    </div>
                ),
            },
        ],
        columnsOfAuth: [
            {
                title: '用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            {
                title: '用户昵称',
                dataIndex: 'nickName',
                key: 'nickName',
            },
            {
                title: '提交认证时间',
                dataIndex: 'authTime',
                key: 'authTime',
            },
            {
                title: '审核时间',
                dataIndex: 'auditTime',
                key: 'auditTime',
            },
            {
                title: '认证渠道',
                key: 'functionType',
                render: (data) => (
                    <div>
                        {data.functionType == 9 ? '视频认证' : (data.functionType == 0 ? '创建公众圈': '')}
                    </div>
                ),
            },
            {
                title: '认证方式',
                key: 'authType',
                render: (data) => (
                    <div>
                        {data.authType == 1 ? '支付宝' : '人工'}
                    </div>
                ),
            },
            {
                title: '认证状态',
                key: 'status',
                render: (data) => (
                    <div>
                        {data.status == 10 ? '待审核' : data.status == 20 ? '已认证' : '认证不通过'}
                    </div>
                ),
            },
            {
                title: '认证信息',
                key: 'showDuration',
                render: (data) => (
                    <div className="operateBtnBlock">
                        <a onClick={this.showDurationModal.bind(this, data)}>查看</a>
                    </div>
                ),
            },
            {
                title: '认证记录',
                key: 'record',
                render: (data) => (
                    <div className="operateBtnBlock">
                        <a onClick={this.viewRecord.bind(this, data.userId)}>查看</a>
                    </div>
                ),
            },
            {
                title: '通过状态',
                key: 'operate',
                render: (data) => (
                    <div>
                        {
                            data.authType==2&&data.status == 10 && <div>
                                <Popconfirm title="确定通过该认证请求吗？"
                                    onConfirm={this.accessOn.bind(this,{authId:data.authId,status:20})}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button key={'sureBtn' + data.userId} type="primary" className="editBtn">通过</Button>
                                </Popconfirm>
                                <Popconfirm title="确定拒绝该认证请求吗？"
                                    onConfirm={this.accessOn.bind(this,{authId:data.authId,status:30})}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button key={'deleteBtn' + data.userId} type="danger" className="deleteBtn">不通过</Button>
                                </Popconfirm>

                            </div>
                        }
                        {
                            data.status == 20 && <div>已通过</div>
                        }
                        {
                            data.status == 30 && <div>已拒绝</div>
                        }
                        {
                            data.authType==1&&data.status == 10 && <div>待审核</div>
                        }
                    </div>
                ),
            },
        ],
        columnsOfFreeze: [
            {
                title: '封禁ID',
                dataIndex: 'freezeId',
                key: 'freezeId',
            },
            {
                title: '用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            {
                title: '用户昵称',
                dataIndex: 'nickName',
                key: 'nickName',
            },
            {
                title: '封禁类型',
                key: 'freezeType',
                render: (data) => (
                    <div>{data.freezeType == 1 ? '公众圈' : '平台'}</div>
                )
            },
            {
                title: '公众圈ID',
                dataIndex: 'circleId',
                key: 'circleId',
            },
            {
                title: '公众圈名称',
                dataIndex: 'circleName',
                key: 'circleName',
            },
            {
                title: '封禁时间',
                dataIndex: 'freezeTime',
                key: 'freezeTime',
            },
            {
                title: '解封时间',
                dataIndex: 'unfreezeTime',
                key: 'unfreezeTime',
            },
            {
                title: '解封',
                key: 'isFreeze',
                render: (data) => (
                    <div className="operateBtnBlock">
                        {
                            data.isFreeze == 0 ? <span>已解封</span> :
                                <Popconfirm title="确定解封该直播吗？"
                                    onConfirm={this.deleteFuncOrDis.bind(this, 'unFreeze', data)}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button key={'unFreezeBtn' + data.freezeId} type="primary" className="deleteBtn">解封</Button>
                                </Popconfirm>
                        }
                    </div>
                ),
            },
        ],
        columnsOfAward: [
            {
                title: '打赏ID',
                dataIndex: 'rewardId',
                key: 'rewardId',
            },
            {
                title: '打赏用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            {
                title: '打赏用户昵称',
                dataIndex: 'userNick',
                key: 'userNick',
            },
            {
                title: '打赏礼物',
                key: 'giftType',
                render: (data) => (
                    <div>{data.giftName}</div>
                )
            },
            {
                title: '打赏数量',
                dataIndex: 'rewardNum',
                key: 'rewardNum',
            },
            {
                title: '礼物价值（铛铛币）',
                dataIndex: 'rewardDdb',
                key: 'rewardDdb',
            },
            {
                title: '打赏时间',
                dataIndex: 'rewardTime',
                key: 'rewardTime',
            },
            {
                title: '场次ID',
                dataIndex: 'showId',
                key: 'showId',
            },
            {
                title: '主播用户ID',
                dataIndex: 'showUserId',
                key: 'showUserId',
            },
            {
                title: '主播用户昵称',
                dataIndex: 'showUserNick',
                key: 'showUserNick',
            },
        ],
        columnsOfRecGoods: [
            {
                title: '场次ID',
                dataIndex: 'showId',
                key: 'showId',
            },
            {
                title: '商品ID',
                dataIndex: 'goodsId',
                key: 'goodsId',
            },
            {
                title: '商品名称',
                dataIndex: 'goodsName',
                key: 'goodsName',
            },
            {
                title:'商品类型',
                dataIndex: 'goodsType',
                render: (data) => (
                    <div>
                        {
                            data!=undefined&&
                            <div>{data == 1 ? '铛铛':'淘宝'}</div>
                        }
                    </div>
                )
            },
            {
                title:'讲解状态',
                dataIndex: 'status',
                render: (data) => (
                    <div>
                        {
                            data!=undefined&&
                            <div>{data == 0 ? '待讲解' : (data == 10 ? '讲解已开始 ' :'讲解已结束')}</div>
                        }
                    </div>
                )
            },
            {
                title: '讲解开始时间',
                dataIndex: 'recStartTime',
                key: 'recStartTime',
            },
            {
                title: '讲解结束时间',
                dataIndex: 'recEndTime',
                key: 'recEndTime',
            },
            {
                title: '讲解时长',
                dataIndex: 'redDuration',
                key: 'redDuration',
            },
            
        ],
        liveSearchCondition: {//直播列表搜索条件
            circleName: '',
            nickName: '',
            userId: '',
            startTime: '',
            endTime: '',
            pageNum: 5,
            pageIndex: 1,
        },
        authSearchCondition: {//实名列表搜索条件
            nickName: '',
            pageNum: 5,
            pageIndex: 1,
            userId: '',
            status: 10
        },
        freezeSearchCondition: {//封禁列表搜索条件
            nickName: '',
            circleName: '',
            pageNum: 5,
            pageIndex: 1,
            freezeType: '',
            isFreeze: '',
        },
        rewardSearchCondition: {//打赏记录搜索条件
            nickName: '',
            userId: '',
            showUserNick: '',
            showUserId: '',
            showId: '',
            rewardStartTime: '',
            rewardEndTime: '',
            pageNum: 5,
            pageIndex: 1
        },
        recGoodSearchCondition: {//带货记录搜索条件
            showId: '',
            pageNum: 5,
            pageIndex: 1,
            circleId:''
        },
        pagination: {
            hideOnSinglePage: true,
            showQuickJumper: true,
            showSizeChanger: false,
            onShowSizeChange: this.onShowSizeChange,
            addModalTitle: '',
            pageSize: 5,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
            onChange: this.onPaginationChange,
        },
    }
    componentDidMount() {
        this.getListData()
        this.getWaitForCheck();
    }
    componentWillReceiveProps() {
        this.getListData();
        this.getWaitForCheck();
    }
    searchForData(type) {//搜索
        const {
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition,
        } = this.state;
        eval(type+'.pageIndex=1');

        this.setState({
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        },()=>{
            this.getListData();
        }) 
    }
    getWaitForCheck=async()=>{
        let searchCondition={//实名列表搜索条件
            nickName: '',
            pageNum: 5,
            pageIndex: 1,
            userId: '',
            status: 10
        }
        let result = await API.getLiveAuthList(searchCondition);
        if (result.status == 1) {
            let waitForCheck=result.data.authCount?result.data.authCount:0;
            this.setState({
                waitForCheck
            })
        }
    }
    deleteFuncOrDis(type,data) {
        console.log(type,data)
        switch(type){
            case 'freeze':
                let {freezeInfoModal}=this.state;
                freezeInfoModal.show=true;
                freezeInfoModal.toUserId=data.userId;
                this.setState({
                    freezeInfoModal
                });
                break;
            case 'unFreeze':
                this.liveUnFreeze({freezeId:data.freezeId})
                break;
            case 'freezeInCircle':
                message.error('暂未提供公众圈封禁功能');
                break;
        }
    }
    goRewardList(showId, userId) {
        const { rewardSearchCondition, pagination } = this.state;
        pagination.current = 1;
        rewardSearchCondition.showId = showId;
        rewardSearchCondition.userId = userId;
        this.setState({
            activeKey: '4',
            pagination,
            rewardSearchCondition
        }, () => {
            this.getListData()
        })
    }
    showDurationModal(data) {
        let { authInfoModal } = this.state;
        authInfoModal = {
            show: true,
            authId:data.authId,
            userName: data.userName,//真实姓名
            userCertNo: data.userCertNo,//身份证号
            userImages: data.userImages,//身份证照片
            certStartTime:data.certStartTime, //证件生效期
            certEndTime:data.certEndTime, //证件失效期
            status: data.status,
        };
        this.setState({ authInfoModal })
    } 
    goRecGoodsList(showId,circleId) {
        const { recGoodSearchCondition, pagination } = this.state;
        pagination.current = 1;
        recGoodSearchCondition.showId = showId;
        recGoodSearchCondition.circleId=circleId;
        this.setState({
            activeKey: '5',
            pagination,
            recGoodSearchCondition
        }, () => {
            this.getListData()
        })
    }
    viewRecord(userId) {
        const { authSearchCondition } = this.state;
        authSearchCondition.userId = userId;
        this.setState({
            authSearchCondition
        }, () => {
            this.getListData();
        })
    }
    TabOnChangeCallback(key) {
        const { pagination, recGoodSearchCondition } = this.state;
        pagination.current = 1;
        recGoodSearchCondition.showId = '';
        recGoodSearchCondition.circleId='';
        this.setState({ activeKey: key, recGoodSearchCondition,pagination}, () => {
            this.getListData()
        })
    }
    getListData=async ()=> {
        const {
            activeKey,
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        } = this.state;
        //搜索条件字段组
        let conditionArr = ['liveSearchCondition', 'authSearchCondition', 'freezeSearchCondition', 'rewardSearchCondition', 'recGoodSearchCondition']
        //更新列表字段组
        let getFunctionArr = ['getLiveList', 'getLiveAuthList', 'getLiveFreezeList', 'getLiveRewardList', 'getLiveRecGoodsList']
        let searchCondition = '';
        eval('searchCondition=' + conditionArr[activeKey - 1]);
        let result;
        switch (getFunctionArr[activeKey - 1]) {
            case 'getLiveList':
                result = await API.getLiveList(searchCondition)
                if (result.status == 1) {
                    let data = result.data;
                    let {pagination} = this.state;
                    pagination.total = Number(data.liveCount);
                    pagination.current=searchCondition.pageIndex;
                    this.setState({
                        totalAmount: data.totalAmount / 100,
                        preTaxAmount: data.currTaxAmount / 100,
                        receiveAmount: data.receiveAmount / 100,
                        showLiveList: data.showLiveList,
                        pagination
                    })
                }
                break;
            case 'getLiveAuthList':
                result = await API.getLiveAuthList(searchCondition)
                if (result.status == 1) {
                    let data = result.data;
                    let {pagination} = this.state;
                    pagination.total = Number(data.authCount);
                    pagination.current=searchCondition.pageIndex;
                    this.setState({
                        showAuthList: data.authList,
                        pagination
                    })
                }
                break;
            case 'getLiveFreezeList':
                result = await API.getLiveFreezeList(searchCondition)
                if (result.status == 1) {
                    let data = result.data;
                    let {pagination} = this.state;
                    pagination.total = Number(data.freezeCount);
                    pagination.current=searchCondition.pageIndex;
                    this.setState({
                        showFreezeList: data.freezeList,
                        pagination
                    })
                }
                break;
            case 'getLiveRewardList':
                result = await API.getLiveRewardList(searchCondition)
                if (result.status == 1) {
                    let data = result.data;
                    let {pagination} = this.state;
                    pagination.total = Number(data.rewardNum);
                    pagination.current=searchCondition.pageIndex;
                    this.setState({
                        showAwardList: data.rewardList,
                        pagination

                    })
                }
                break;
            case 'getLiveRecGoodsList':
                result = await API.getLiveRecGoodsList(searchCondition)
                if (result.status == 1) {
                    let data = result.data;
                    let {pagination} = this.state;
                    pagination.total = Number(data.goodsNum);
                    pagination.current=searchCondition.pageIndex;
                    this.setState({
                        showRecGoodsList: data&&data.goodsList,
                        pagination
                    })
                }
                break;
        }

    }
    liveFreeze =async (params)=> {
        const {freezeInfoModal}=this.state;
        let result=await API.liveFreeze(params)
        freezeInfoModal.show=false;
        this.setState({freezeInfoModal})
        if(result.status==1){
            message.success('封禁成功');
            this.getListData();
            return;
        }
        message.error(result.msg);
    }
    liveUnFreeze =async (params)=> {
        let result=await API.liveUnfreeze(params)
        if(result.status==1){
            message.success('解禁成功');
            this.getListData();
            return;
        }
        message.error(result.msg);
    }
    onPaginationChange(pageCounter) {

    }
    onShowSizeChange(current, pageSize) {
    }
    InputItemChange(type, target, e) {
        let value = e.target.value.trim();//不能缺少的声明 eval表达式需要用到value
        const {
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        } = this.state;
        eval(type + '.' + target + '=value');//利用eval转换字符串为表达式 省几行代码
        this.setState({
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        })
    }
    freezeInfoChange(e){
        const {freezeInfoModal}=this.state;
        freezeInfoModal.reason=e.target.value;
        this.setState({freezeInfoModal})
    }
    onSearchDateChange = (type, date) => { //筛选条件 ：时间范围
        console.log(type)
        const {
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        } = this.state;
        let startTime = '', endTime = '';
        if (date.length == 0) {
            startTime = '';
            endTime = '';
        } else {
            startTime = Math.floor(date[0].valueOf()/1000);
            endTime =  Math.floor(date[1].valueOf()/1000);
        }
        switch (type) {
            case 'live':
                liveSearchCondition.startTime = startTime;
                liveSearchCondition.endTime = endTime;
                break;
            case 'reward':
                rewardSearchCondition.rewardStartTime = startTime;
                rewardSearchCondition.rewardEndTime = endTime;
                break;
        }

        this.setState({
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        });
    }
    clearAuthUserId() {
        const { authSearchCondition } = this.state;
        authSearchCondition.userId = '';
        this.setState({ authSearchCondition }, () => {
            this.getListData();
        })
    }
    onSelectChange(type, target, value) {//下拉框更改
        const {
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        } = this.state;
        eval(type + '.' + target + '=value');
        this.setState({
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        });
    }
    handleTableChange = (pagination, filters, sorter) => {
        const {
            activeKey,
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        } = this.state;
        let conditionArr = ['liveSearchCondition', 'authSearchCondition', 'freezeSearchCondition', 'rewardSearchCondition', 'recGoodSearchCondition']
        eval(conditionArr[activeKey - 1] + '.pageIndex=' + pagination.current)
        this.setState({
            pagination,
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        }, () => {
            this.getListData();
        });
    };
    freezeLive(){
        const {freezeInfoModal}=this.state;
        let param={
            toUserId:freezeInfoModal.toUserId,
            reason:freezeInfoModal.reason,
            isAction:1
        }
        console.log(param)
        this.liveFreeze(param)
    }
    handleAddModalCancel(type){//添加或编辑对话框点击取消后
        const { authInfoModal,freezeInfoModal} = this.state;
        if(type=='auth'){
            authInfoModal.show = false;
        }
        else if(type=='freeze'){
            freezeInfoModal.show = false;
            freezeInfoModal.reason='';
            freezeInfoModal.toUserId='';
        }
        this.setState({ authInfoModal,freezeInfoModal})
    }
    clearNull(obj) {//删除对象中为空的属性
        for (let key in obj) {
            if (obj[key] === '') {
                delete (obj[key])
            }
        }
        return obj
    }
    accessOn=async (param)=> {//认证通过状态
        let result=await API.liveCheck(param);
        const {authInfoModal}=this.state;
        authInfoModal.status=param.status;
        this.setState({authInfoModal})
        if(result.status==1){
            let msg=param.status==20?'已认证通过':'已拒绝认证通过';
            message.success(msg)
            this.getListData();
            this.getWaitForCheck();
            return;
        }
        message.error(result.msg)
    }
    render() {
        const {
            totalAmount,
            preTaxAmount,
            receiveAmount,
            columnsOfLive,
            columnsOfAuth,
            columnsOfFreeze,
            columnsOfAward,
            columnsOfRecGoods,
            showLiveList,
            showAuthList,
            showFreezeList,
            showAwardList,
            showRecGoodsList,
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition,
            pagination,
            loading,
            activeKey,
            authInfoModal,
            freezeInfoModal,
            waitForCheck
        } = this.state;
        let columnsOfAuthReal = columnsOfAuth.slice();
        if (authSearchCondition.userId && columnsOfAuth[7].key == 'record') {
            columnsOfAuthReal.splice(7, 1)
        }
        return (
            <ConfigProvider locale={zhCN}>
                <div className="LiveInfoListPane">
                    <Tabs activeKey={activeKey} onChange={this.TabOnChangeCallback.bind(this)}>
                        <TabPane tab="直播列表" key="1">
                            <div className="searchPane">
                                <div className="leftCondition">
                                    <div className="inputPane">
                                        <Input value={liveSearchCondition.circleName} onChange={this.InputItemChange.bind(this, 'liveSearchCondition', 'circleName')} placeholder="公众圈名称"></Input>
                                        <Input value={liveSearchCondition.nickName} onChange={this.InputItemChange.bind(this, 'liveSearchCondition', 'nickName')} placeholder="直播用户昵称"></Input>
                                        <Input value={liveSearchCondition.userId} onChange={this.InputItemChange.bind(this, 'liveSearchCondition', 'userId')} placeholder="直播用户ID"></Input>
                                    </div>
                                    <RangePicker
                                        className="rangePicker"
                                        showTime={{ format: 'HH:mm:ss' }}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onSearchDateChange.bind(this, 'live')}
                                    ></RangePicker>
                                    <div className="info">
                                        <span>收入铛铛币 ￥{totalAmount}</span>
                                        <span>预扣税款 ￥{preTaxAmount}</span>
                                        <span>税后收入 ￥{receiveAmount}</span>
                                    </div>
                                </div>
                                <Button onClick={this.searchForData.bind(this, 'liveSearchCondition')}>搜索</Button>
                            </div>
                            <Table columns={columnsOfLive}
                                dataSource={showLiveList}
                                pagination={pagination}
                                onChange={this.handleTableChange}
                                rowKey={(row,index) => 'liveList' + row.showId+'-'+index}
                            />
                            <Modal
                                destroyOnClose={true}
                                title='封禁原因'
                                onCancel={this.handleAddModalCancel.bind(this,'freeze')}
                                visible={freezeInfoModal.show}
                                width={500}
                                footer={
                                    [
                                        <Button key="submit" type="primary" onClick={this.handleAddModalCancel.bind(this,'freeze')}>取消</Button>,
                                        <Button key="back" type="danger" onClick={this.freezeLive.bind(this)}>封禁</Button>,
                                    ]
                                }
                            >
                                <div className="modalPane">
                                    <TextArea placeholder="请简要描述封禁原因" onChange={this.freezeInfoChange.bind(this)}></TextArea>
                                </div>
                            </Modal>
                        </TabPane>
                        <TabPane tab={'实名认证('+waitForCheck+')'} key="2">
                            {
                                !authSearchCondition.userId &&
                                <div className="searchPane">
                                    <div className="inputPane">
                                        <Select className="selectBlock" value={authSearchCondition.status + ''} onChange={this.onSelectChange.bind(this, 'authSearchCondition', 'status')}>
                                            <Option value="">全部</Option>
                                            <Option value="10">待审核</Option>
                                            <Option value="20">已认证</Option>
                                            <Option value="30">认证不通过</Option>
                                        </Select>
                                        <Input value={authSearchCondition.nickName} onChange={this.InputItemChange.bind(this, 'authSearchCondition', 'nickName')} placeholder="用户昵称"></Input>
                                    </div>
                                    <Button onClick={this.searchForData.bind(this, 'authSearchCondition')}>搜索</Button>
                                </div>
                            }
                            {
                                authSearchCondition.userId &&
                                <div className="searchPane">
                                    <Button onClick={this.clearAuthUserId.bind(this)}>返回全部</Button>
                                </div>
                            }
                            <Table columns={columnsOfAuthReal}
                                dataSource={showAuthList}
                                pagination={pagination}
                                onChange={this.handleTableChange}
                                rowKey={(row,index) => 'authList' + row.authId+'-'+index}
                            />
                            <Modal
                                destroyOnClose={true}
                                title='认证信息'
                                onCancel={this.handleAddModalCancel.bind(this,'auth')}
                                visible={authInfoModal.show}
                                width={500}
                                footer={
                                    authInfoModal.status == 10 ?
                                        [
                                            <Button key="submit" type="primary" onClick={this.accessOn.bind(this,{authId:authInfoModal.authId,status:20})}>认证通过</Button>,
                                            <Button key="back" type="danger" onClick={this.accessOn.bind(this,{authId:authInfoModal.authId,status:30})}>认证不通过 </Button>,
                                        ] 
                                        : authInfoModal.status == 20 ?
                                            [
                                                <Button key="submit" disabled type="" onClick={this.handleAddModalCancel.bind(this,'auth')}>已认证通过 </Button>
                                            ]
                                            :
                                            [
                                                <Button key="submit" disabled type="primary" onClick={this.handleAddModalCancel.bind(this,'auth')}>已拒绝通过</Button>
                                            ]
                                }
                            >
                                <div className="modalPane">
                                    <div className="displayItem">
                                        <span className="title">真实姓名</span>
                                        <span className="info">
                                            {authInfoModal.userName}
                                        </span>
                                    </div>
                                    <div className="displayItem">
                                        <span className="title">身份证号</span>
                                        <span className="info">
                                            {authInfoModal.userCertNo}
                                        </span>
                                    </div>
                                    <div className="displayItem">
                                        <span className="title">证件生效期</span>
                                        <span className="info">
                                            {authInfoModal.certStartTime}
                                        </span>
                                    </div>
                                    <div className="displayItem">
                                        <span className="title">证件失效期</span>
                                        <span className="info">
                                            {authInfoModal.certEndTime}
                                        </span>
                                    </div>
                                    {
                                        authInfoModal.userImages && authInfoModal.userImages.length > 0 &&
                                        <div className="displayItem">
                                            <span className="title">身份证正面照</span>
                                            <div className="pic" >
                                                <img src={authInfoModal.userImages[0]}></img>
                                            </div>
                                        </div>
                                    }
                                    {
                                        authInfoModal.userImages && authInfoModal.userImages.length > 1 &&
                                        <div className="displayItem">
                                            <span className="title">身份证背面照</span>
                                            <div className="pic" >
                                                <img src={authInfoModal.userImages[1]}></img>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Modal>
                        </TabPane>
                        <TabPane tab="封禁列表" key="3">
                            <div className="searchPane">
                                <div className="inputPane">
                                    <Select className="selectBlock" value={freezeSearchCondition.isFreeze + ''} onChange={this.onSelectChange.bind(this, 'freezeSearchCondition', 'isFreeze')}>
                                        <Option value="">全部</Option>
                                        <Option value="1">封禁中</Option>
                                    </Select>
                                    <Select className="selectBlock" value={freezeSearchCondition.freezeType + ''} onChange={this.onSelectChange.bind(this, 'freezeSearchCondition', 'freezeType')}>
                                        <Option value="">全部</Option>
                                        <Option value="1">公众圈封禁</Option>
                                        <Option value="2">平台封禁</Option>
                                    </Select>
                                    <Input value={freezeSearchCondition.nickName} onChange={this.InputItemChange.bind(this, 'freezeSearchCondition', 'nickName')} placeholder="用户昵称"></Input>
                                    <Input value={freezeSearchCondition.circleName} onChange={this.InputItemChange.bind(this, 'freezeSearchCondition', 'circleName')} placeholder="公众圈名称"></Input>
                                </div>
                                <Button onClick={this.searchForData.bind(this, 'freezeSearchCondition')}>搜索</Button>
                            </div>
                            <Table columns={columnsOfFreeze}
                                dataSource={showFreezeList}
                                onChange={this.handleTableChange}
                                pagination={pagination}
                                rowKey={(row,index) => 'freezeList' + row.freezeId+'-'+index}
                            />
                        </TabPane>
                        <TabPane tab="打赏记录" key="4">
                            <div className="searchPane">
                                <div className="leftCondition">
                                    <div className="inputPane">
                                        <Input value={rewardSearchCondition.nickName} onChange={this.InputItemChange.bind(this, 'rewardSearchCondition', 'nickName')} placeholder="打赏用户昵称"></Input>
                                        <Input value={rewardSearchCondition.userId} onChange={this.InputItemChange.bind(this, 'rewardSearchCondition', 'userId')} placeholder="打赏用户ID"></Input>
                                        <Input value={rewardSearchCondition.showUserNick} onChange={this.InputItemChange.bind(this, 'rewardSearchCondition', 'showUserNick')} placeholder="打赏主播昵称"></Input>
                                        <Input value={rewardSearchCondition.showUserId} onChange={this.InputItemChange.bind(this, 'rewardSearchCondition', 'showUserId')} placeholder="打赏主播ID"></Input>
                                        <Input value={rewardSearchCondition.showId} onChange={this.InputItemChange.bind(this, 'rewardSearchCondition', 'showId')} placeholder="场次ID"></Input>
                                    </div>
                                    <RangePicker
                                        className="rangePicker"
                                        showTime={{ format: 'HH:mm:ss' }}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onSearchDateChange.bind(this, 'reward')}
                                    ></RangePicker>
                                </div>
                                <Button onClick={this.searchForData.bind(this, 'rewardSearchCondition')}>搜索</Button>
                            </div>
                            <Table columns={columnsOfAward}
                                dataSource={showAwardList}
                                pagination={pagination}
                                onChange={this.handleTableChange}
                                rowKey={(row,index) => 'awardList' + row.rewardId+'-'+index}
                            />
                        </TabPane>
                        <TabPane tab="带货记录" key="5">
                            <div className="searchPane">
                            </div>
                            <Table columns={columnsOfRecGoods}
                                dataSource={showRecGoodsList}
                                pagination={pagination}
                                onChange={this.handleTableChange}
                                rowKey={(row,index) => 'recGoodList' + row.goodsId+'-'+index}
                            />
                        </TabPane>
                    </Tabs>
                </div>
            </ConfigProvider>
        )
    }
}

export default LiveInfoList;